<template>
  <div class="tabs-container">
    <div class="tabs-header">
      <button
        v-for="tab in tabs"
        :key="tab.key"
        :class="['tab-button', { active: currentTab === tab.key }]"
        @click="changeTab(tab.key)"
        type="button"
      >
        {{ tab.label }}
      </button>
    </div>
    <div class="tabs-content">
      <slot :name="currentTab"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "TabContainer",
  props: {
    tabs: {
      type: Array,
      required: true,
      validator: (tabs) => {
        return tabs.every((tab) => tab.key && tab.label);
      },
    },
    defaultTab: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      currentTab:
        this.defaultTab || (this.tabs.length > 0 ? this.tabs[0].key : ""),
    };
  },
  methods: {
    changeTab(tabKey) {
      this.currentTab = tabKey;
      this.$emit("tab-changed", tabKey);
    },
  },
  watch: {
    defaultTab(newVal) {
      if (newVal) {
        this.currentTab = newVal;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.tabs-container {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.tabs-header {
  display: flex;
  border-bottom: 2px solid #e5e7eb;
  margin-bottom: 1.5rem;
  gap: 0;
}

.tab-button {
  flex: 1;
  padding: 0.875rem 1.5rem;
  font-size: 0.9375rem;
  font-weight: 500;
  color: #6b7280;
  background-color: transparent;
  border: none;
  border-bottom: 3px solid transparent;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;

  &:hover {
    color: #3b82f6;
    background-color: #f3f4f6;
  }

  &.active {
    color: #3b82f6;
    border-bottom-color: #3b82f6;
    background-color: #eff6ff;
  }

  &:focus {
    outline: none;
    box-shadow: inset 0 0 0 2px #3b82f6;
  }
}

.tabs-content {
  padding-top: 0.5rem;
}

/* Dark mode support */
:global(.dark) .tabs-header {
  border-bottom-color: #374151;
}

:global(.dark) .tab-button {
  color: #9ca3af;

  &:hover {
    color: #60a5fa;
    background-color: #1f2937;
  }

  &.active {
    color: #60a5fa;
    border-bottom-color: #60a5fa;
    background-color: #000;
  }
}

/* Mobile responsiveness */
@media (max-width: 640px) {
  .tab-button {
    padding: 0.75rem 1rem;
    font-size: 0.875rem;
  }
}
</style>
